import gql from 'graphql-tag'

export const GET_PLACES = gql`
  query($filter: Filter) {
    places(filter: $filter) {
      id
      businessId
      alias
      subject
      category
      state
      status
      employeePercent
      attachments
      description
      province
      county
      district
      borough
      location {
        lat
        lon
      }
      services {
        id
        state
        status
        placeId
        employeeId
        startDate
        specialty
        endDate
      }
    }
  }
`

export const GET_PLACE = gql`
  query($id: String!) {
    place(id: $id) {
      id
      businessId
      alias
      subject
      category
      state
      status
      employeePercent
      attachments
      description
      province
      county
      district
      borough
      location {
        lat
        lon
      }
      services {
        id
        state
        status
        placeId
        employeeId
        startDate
        specialty
        endDate
      }
    }
  }
`
